import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import DownloadPdf from '../DownloadPdf';

import { PrimaryColor, PrimaryDarkColor, White } from '../styles/colors';

import IconDownload from './Icon-Download.svg';

const DEFAULT_LABEL = 'Material herunterladen';

const A = styled(DownloadPdf)`
  display: inline-block;
  font-family: 'PT Mono', monospace;
  font-weight: bold;
  font-size: 16px;

  text-decoration: none;
  cursor: pointer;

  line-height: 1.2;

  background-color: ${PrimaryColor};
  color: ${White};

  &:hover, &:visited {
    color: ${White};
    text-decoration: none;
    background-color: ${PrimaryDarkColor};
  }
`;

const IconImg = styled.img`
  margin-right: 1rem;
`;

const renderIcon = (noicon, label) => (noicon ? null : (
  <IconImg width="25" height="22" src={IconDownload} alt={label} />
));

const renderLabel = (nolabel, label) => (nolabel ? null : (
  <span>
    { label }
  </span>
));

const DownloadMaterialButton = ({
  className,
  download,
  href,
  label,
  noicon,
  nolabel,
}) => (
  <A href={href} download={download} className={className}>
    { renderIcon(noicon, label) }
    { renderLabel(nolabel, label) }
  </A>
);

DownloadMaterialButton.propTypes = {
  nolabel: PropTypes.bool,
  noicon: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string,
  download: PropTypes.string,
};

DownloadMaterialButton.defaultProps = {
  nolabel: false,
  noicon: false,
  label: DEFAULT_LABEL,
  className: undefined,
  href: undefined,
  download: undefined,
};

export default DownloadMaterialButton;



// WEBPACK FOOTER //
// ./src/components/DownloadMaterialButton/DownloadMaterialButton.js